import { BaseModel, type RelationConfig } from './base';

// Enums

export enum MarketingMessageChannel {
  email = 'email',
  sms = 'sms',
}

export const MarketingMessageChannelLabels: Record<MarketingMessageChannel, string> = {
  [MarketingMessageChannel.email]: 'general.email',
  [MarketingMessageChannel.sms]: 'general.sms',
};

// Helper Classes

export class MarketingTemplate extends BaseModel {
  name!: string;
  subject!: string;
  body!: string;
  placeholders!: string[];
}

export class MarketingTemplateResponse extends BaseModel {
  placeholders!: string[];
  links!: { name: string; text: string; placeholder: string }[];
  template!: MarketingTemplate | null;

  static override relations(): RelationConfig {
    return {
      template: { type: MarketingTemplate },
    };
  }
}

export class SentSMSInfo extends BaseModel {}

export class MarketingMessage extends BaseModel {
  id!: number;
  channel!: MarketingMessageChannel;
  created!: number;
  to!: string;
  type!: string;
  subject?: string | null;
  body?: string | null;
  customer?: { idCustomer: number; displayName: string } | null;
  status!: Record<string, boolean>;
  cost?: { price: number; unit: string } | null;

  get isChannelEmail(): boolean {
    return this.channel === MarketingMessageChannel.email;
  }

  get isChannelSMS(): boolean {
    return this.channel === MarketingMessageChannel.sms;
  }
}
